"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonsSink = void 0;
const icons_1 = require("client/components/icons");
const button_1 = require("client/components/material/button");
const icon_button_1 = require("client/components/material/icon-button");
const button_2 = require("client/components/ui/button");
const icon_button_2 = require("client/components/ui/icon-button");
const text_button_1 = require("client/components/ui/text-button");
const Add_1 = require("material-ui-icons/Add");
const Apps_1 = require("material-ui-icons/Apps");
const react_1 = require("react");
const React = require("react");
require("./buttons.less");
class ButtonsSink extends react_1.Component {
    render() {
        return (React.createElement("div", { className: "buttons" },
            React.createElement("h2", null, "Buttons"),
            React.createElement(button_2.UiButton, { disabled: true }, "Disabled Button"),
            React.createElement(button_2.UiButton, null, "Cancel Button"),
            React.createElement(button_2.UiButton, { primary: true, disabled: true }, "Disabled Primary Button"),
            React.createElement(button_2.UiButton, { primary: true }, "Primary Button"),
            React.createElement("h2", null, "Icon Buttons"),
            React.createElement(icon_button_2.UiIconButton, null,
                React.createElement(icons_1.MenuIcon, null)),
            React.createElement(icon_button_2.UiIconButton, { primary: true, small: true },
                React.createElement(icons_1.MenuIcon, { fill: "#fff" })),
            React.createElement("h2", null, "Text Buttons"),
            React.createElement(text_button_1.UiTextButton, { disabled: true }, "Disabled Text Button"),
            React.createElement(text_button_1.UiTextButton, null, "Text Button"),
            React.createElement(text_button_1.UiTextButton, { primary: true, disabled: true }, "Disabled Primary Text Button"),
            React.createElement(text_button_1.UiTextButton, { primary: true }, "Primary Text Button"),
            React.createElement("h2", null, "Material Buttons"),
            React.createElement("h3", null, "Normal"),
            React.createElement(button_1.MaterialButton, null, "Default"),
            React.createElement(button_1.MaterialButton, { primary: true }, "Primary Button"),
            React.createElement(button_1.MaterialButton, { secondary: true }, "Secondary Text Button"),
            React.createElement(button_1.MaterialButton, { disabled: true }, "Disabled Text Button"),
            React.createElement(button_1.MaterialButton, { primary: true, disabled: true }, "Primary Disabled Button"),
            React.createElement("h3", null, "Flat"),
            React.createElement(button_1.MaterialButton, { flat: true }, "Default"),
            React.createElement(button_1.MaterialButton, { flat: true, primary: true }, "Primary Button"),
            React.createElement(button_1.MaterialButton, { flat: true, secondary: true }, "Secondary Text Button"),
            React.createElement(button_1.MaterialButton, { flat: true, disabled: true }, "Disabled Text Button"),
            React.createElement("h3", null, "Fab"),
            React.createElement(button_1.MaterialButton, { fab: true },
                React.createElement(Add_1.default, null)),
            React.createElement(button_1.MaterialButton, { fab: true, primary: true },
                React.createElement(Add_1.default, null)),
            React.createElement(button_1.MaterialButton, { fab: true, secondary: true },
                React.createElement(Add_1.default, null)),
            React.createElement(button_1.MaterialButton, { fab: true, disabled: true },
                React.createElement(Add_1.default, null)),
            React.createElement("h3", null, "Icon Button"),
            React.createElement(icon_button_1.MaterialIconButton, null,
                React.createElement(Apps_1.default, null)),
            React.createElement(icon_button_1.MaterialIconButton, { disabled: true },
                React.createElement(Apps_1.default, null))));
    }
}
exports.ButtonsSink = ButtonsSink;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/kitchen-sink/buttons/buttons.tsx
// module id = 3616
// module chunks = 0